module.exports = __webpack_public_path__ + "img/img_product_6steps@2x.613158c3.png";